export const URL_BASE = '/sam/showcase/preview'

export function GetUrlIndex(router) {
  return URL_BASE + '/home/'
}

export function GetUrlWork(router) {
  return URL_BASE + '/art/'
}

export function GetUrlNews(router) {
  return URL_BASE + '/news/'
}

export function GetUrlAbout(router) {
  return URL_BASE + '/about/'
}

export function GetUrlContact(router) {
  return URL_BASE + '/contact/'
}
